/**
 * SubscriptionSection.tsx
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Textes : subscription.features.<id>
const FEATURES = ['search', 'decisions', 'fiches', 'graph', 'baudelinius', 'mcp', 'assistants', 'daily'];

export const SubscriptionSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-background border-t border-border">
      <div className="max-w-[1100px] mx-auto px-6 sm:px-8">

        {/* ── Header centré ── */}
        <div className="text-center mb-12">
          <span className="block text-[10px] font-bold uppercase tracking-[.16em] text-violet-600 dark:text-violet-400 mb-4">
            {t('subscription.eyebrow')}
          </span>
          <h2 className="font-serif text-[40px] sm:text-[54px] font-bold text-foreground tracking-[-0.03em] leading-tight">
            {t('subscription.title_start')}<br />
            <em className="not-italic text-violet-600 dark:text-violet-400">{t('subscription.title_highlight')}</em>
          </h2>
        </div>

        {/* ── Carte pricing centrale ── */}
        <div className="max-w-[720px] mx-auto rounded-2xl border border-border bg-card shadow-sm px-8 sm:px-12 py-10">

          {/* Badge pill */}
          <div className="flex justify-center mb-8">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-4 py-1.5 rounded-full border border-violet-300 dark:border-violet-700 bg-violet-50 dark:bg-violet-950/30 text-violet-600 dark:text-violet-400">
              {t('subscription.badge')}
            </span>
          </div>

          {/* Prix */}
          <div className="text-center mb-2">
            <div className="inline-flex items-end gap-2">
              <span className="font-serif text-[72px] sm:text-[80px] font-bold leading-none tracking-[-0.04em] text-foreground">
                {t('subscription.price_amount')}
              </span>
              <span className="text-[20px] font-medium text-muted-foreground mb-3">
                {t('subscription.price_unit')}
              </span>
            </div>
          </div>
          <p className="text-center text-[13px] text-muted-foreground mb-8">
            {t('subscription.no_commitment')}
          </p>

          {/* Séparateur */}
          <div className="h-px bg-border mb-8" />

          {/* Features 2 colonnes */}
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3.5 mb-10">
            {FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-3 text-[13px] text-foreground">
                <svg
                  className="w-4 h-4 flex-shrink-0 text-violet-600 dark:text-violet-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
                {t(`subscription.features.${f}`)}
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="flex justify-center mb-5">
            <Link
              to="/pricing"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl bg-violet-600 text-white text-[15px] font-bold hover:bg-violet-700 transition-colors shadow-md shadow-violet-600/20"
            >
              {t('menu.subscribe_cta')}
            </Link>
          </div>

          {/* Note bas */}
          <p className="text-center text-[12px] text-muted-foreground">
            {t('subscription.free_note')}
          </p>

        </div>
      </div>
    </section>
  );
};